const httpUrl = {
  // baseUrl: 'https://yuanshanqeh.jm688.top/prod-api',
  baseUrl: 'https://openapi.farhilltour.com/prod-api',
  // baseUrl: 'http://4mvsaj.natappfree.cc',
}
export default httpUrl
